import React from 'react';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';

import { Input } from '../form';
import Icons from '@/const/icons';
import { Avatar, Typography } from '@/components/common';
import { LawyerClientsItem } from '@/interfaces/inbox';

interface Props {
	listClients: LawyerClientsItem[];
	setClientSelected: (
		id: string,
		name: string,
		lastname: string,
		profile_picture: string
	) => void;
}

export const ListCaseUsersComponent: React.FC<Props> = ({
	listClients,
	setClientSelected,
}) => {
	const { register } = useForm();
	const [clients, setClients] = React.useState(listClients);

	React.useEffect(() => {
		setClients(listClients);
	}, [listClients]);

	const handleSearch = (value: string): void => {
		const filteredClients = listClients.filter((client) => {
			const username = `${client.firstname} ${client.lastname}`;
			return username.toLowerCase().includes(value.toLowerCase());
		});
		setClients(filteredClients);
	};
	return (
		<div className="lg:w-[720px] h-[25rem] lg:h-[30rem] mt-8">
			<div className="absolute w-[90%] left-4 lg:left-10 top-[5rem]">
				<Input
					name="search"
					register={register}
					placeholder="Search"
					iconLeft={Icons.search}
					classNameIcon={'!top-[23%] !w-4 !h-4 text-opacity-black'}
					classNameInput="pl-9 !bg-gray-15 !h-[33px] !m-0 border-none"
					onChange={({ target }) => handleSearch(target.value)}
				/>
			</div>
			<ul className="">
				{clients.map((client, index) => (
					<li
						key={'case-inquire-' + index}
						className={clsx(
							'border border-transparent rounded-xl',
							'hover:bg-grey-5 p-4 text-left cursor-pointer',
							'hover:border-green-base active:border-none',
							'active:bg-green-secondary focus:bg-green-secondary',
							'flex items-center gap-2 border-b border-[#0D061614]'
						)}
						onClick={() =>
							setClientSelected(
								client.id,
								client.firstname,
								client.lastname,
								client.profile_picture
							)
						}
					>
						<Avatar
							photoUrl={client.profile_picture}
							size="small"
							firstname={`${client.firstname}`}
							lastname={client.lastname}
						/>
						<Typography
							type="regular-14"
							className="capitalize"
						>{`${client.firstname} ${client.lastname}`}</Typography>
					</li>
				))}
			</ul>
		</div>
	);
};
